import { render, staticRenderFns } from "./LayoutDesktop.vue?vue&type=template&id=08faa687&scoped=true&"
var script = {}
import style0 from "./LayoutDesktop.vue?vue&type=style&index=0&id=08faa687&lang=scss&"
import style1 from "./LayoutDesktop.vue?vue&type=style&index=1&id=08faa687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08faa687",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08faa687')) {
      api.createRecord('08faa687', component.options)
    } else {
      api.reload('08faa687', component.options)
    }
    module.hot.accept("./LayoutDesktop.vue?vue&type=template&id=08faa687&scoped=true&", function () {
      api.rerender('08faa687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/layouts/LayoutDesktop.vue"
export default component.exports